import React from 'react';
import PropTypes from 'prop-types';
import {Checkbox, TableCell, TableHead, TableRow, TableSortLabel} from "@material-ui/core";
import ScreenDesignerListHoc from "../../../../../../../../../HocHelpers/ScreenDesignerListHoc";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../../JsonScreen/Utils/lib";

const TableHeaderList = (props) => {
    const {loading, columns, gridProps: {selectable, sortable}} = props;
    return (
        !loading && (
            <TableHead>
                <TableRow style={{height: 27}}>
                    {selectable && (
                        <TableCell padding={"checkbox"}>
                            <Checkbox
                                disabled
                                style={{padding: 0}}
                                color={"primary"}
                                indeterminate={false}
                                checked={false}
                            />
                        </TableCell>
                    )}
                    <RenderCell
                        columns={columns}
                        sortable={sortable}
                    />
                </TableRow>
            </TableHead>
        )
    )
};
export default ScreenDesignerListHoc(TableHeaderList);
TableHeaderList.propTypes = {
    loading: PropTypes.bool,
    columns: PropTypes.array,
    gridProps: PropTypes.object
};
TableHeaderList.defaultProps = {
    columns: [],
    gridProps: {}
};


const RenderCell = ({columns, sortable}) => {
    const {userLanguage} = useSelector(state => state.app);

    return (
        columns.map(({hidden, label, name, width}, index) => {
            const multiLanguageLabel = multiLanguageValue(label, userLanguage);
            return (
                !hidden ? (
                    <TableCell
                        key={index}
                        style={{whiteSpace: 'nowrap', width: width ? width : 'auto'}}
                    >
                        {sortable ? (
                            <TableSortLabel>
                                {multiLanguageLabel ? multiLanguageLabel : name}
                            </TableSortLabel>
                        ) : (multiLanguageLabel ? multiLanguageLabel : name)}
                    </TableCell>
                ) : (<></>)
            )
        })
    )
};